import { call, put, select, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { ActionType, ManagementReportFilters } from './types';
import ManagementReportApi from '../../services/ManagementReportApi';
import { managementReportSuccess, managementReportFailure } from './actionCreators';
import { HttpRequestError } from '../../types';
import { AppState } from '../AppState';

const filtersSelector = (state: AppState) => state.managementReport.filters;

function* fetchManagementReport() {
  const filters: ManagementReportFilters = yield select(filtersSelector);

  if (!filters.countryCode || !filters.startDate || !filters.endDate) {
    return;
  }

  // Format the date range for the backend: "YYYY-MM-DD,YYYY-MM-DD"
  const start = filters.startDate.toISOString().split('T')[0];
  const end = filters.endDate.toISOString().split('T')[0];
  const dateRange = `${start},${end}`;

  try {
    const { data }: AxiosResponse = yield call(ManagementReportApi.getManagementReport, {
      countryAcronym: filters.countryCode,
      accountingDateRange: dateRange,
    });
    yield put(managementReportSuccess(data));
  } catch (error) {
    yield put(managementReportFailure(error as HttpRequestError));
  }
}

export default [takeLatest(ActionType.managementReportRequested, fetchManagementReport)];
